import React from 'react';

import isArchived from 'archive/isArchived';
import {V2RequestsFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {getFeatureStatus} from 'auth/feature-enablement/FeatureStatus';
import {ActionOrigin} from 'constants/AnalyticsConstants';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {Section as NavSection} from 'constants/NavConstants';
import SidepanelItem from 'nav/sidepanel/listing/SidepanelItem';
import SidepanelStore from 'nav/sidepanel/SidepanelStore';
import notifications from 'notifications';
import CreateRequestV2SubmissionModal from 'processes/requests_v2/modals/CreateRequestV2SubmissionModal';
import {ListableItem} from 'search/SearchConstants';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import runModal from 'ui-library/runModal';
import {ellipsize} from 'util/NameUtil';

import {RequestV2DefinitionListingGraphQL} from '../../../../graphql-fragments/processes/requests-v2/__generated/RequestV2DefinitionListingGraphQL';

export interface RequestV2DefinitionSidepanelItemProps {
  isActive: boolean;
  isCompact: boolean;
  openResult: (item: ListableItem) => void;
  requestV2Definition: RequestV2DefinitionListingGraphQL;
  isChild: boolean;
}

export default function RequestV2DefinitionSidepanelItem({
  isActive,
  isCompact,
  requestV2Definition,
  isChild,
  openResult,
}: RequestV2DefinitionSidepanelItemProps): JSX.Element {
  const subtitle = ellipsize(requestV2Definition.description ?? '', 100);
  return (
    <SidepanelItem
      active={isActive}
      className="sidepanelItem--noIcon"
      faded={isArchived(requestV2Definition)}
      icon={<BenchlingIcon icon={ModelTypeConstants.REQUEST_V2_DEFINITION} />}
      isCompact={isCompact}
      onClick={() => {
        const featureStatus = getFeatureStatus({feature: V2RequestsFeature.V2_REQUESTS_CREATE});
        if (featureStatus.enabled) {
          if (SidepanelStore.getSection() === NavSection.REQUESTS_V2_DEFINITIONS) {
            runModal(CreateRequestV2SubmissionModal, {
              initialRequestV2DefinitionId: requestV2Definition.id,
              actionOrigin: ActionOrigin.SEARCH_SIDEPANEL,
            });
          } else {
            openResult(requestV2Definition);
          }
        } else if (featureStatus.userMessage != null) {
          notifications.warn(featureStatus.userMessage);
        }
      }}
      subTitle={subtitle}
      title={{
        text: requestV2Definition.name,
        node: <div>{requestV2Definition.name}</div>,
      }}
      tooltipText=""
      onContextMenu={(e: React.SyntheticEvent) => {}}
      isExpandable={false}
      isChild={isChild}
    />
  );
}
